import { getTrappRouteStore } from '../modules/trappRoute';

export const TrappRoute = getTrappRouteStore();
